import { Typo } from "../Typo";

export type PlatformToggleOption = {
  label: string;
  value: string;
};

export type PlatformToggleProps = {
  options: PlatformToggleOption[];
  selected: string[];
  onChange: (selected: string[]) => void;
  label?: string;
  layout?: "stacked" | "inline";
  hideDivider?: boolean;
};

export const PlatformToggle = ({
  options,
  selected,
  onChange,
  label,
  layout = "stacked",
  hideDivider = false,
}: PlatformToggleProps) => {
  const handleToggle = (value: string) => {
    if (selected.includes(value)) {
      onChange(selected.filter((s) => s !== value));
    } else {
      onChange([...selected, value]);
    }
  };

  const buttons = (
    <div className="flex gap-2">
      {options.map((option) => {
        const isActive = selected.includes(option.value);
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => handleToggle(option.value)}
            className={`flex h-8 min-w-[64px] items-center justify-center rounded-lg px-4 transition-colors lg:h-10 lg:min-w-[80px] ${
              isActive
                ? "bg-surface-inverse-primary text-white"
                : "bg-surface-tonal-default text-text-primary hover:bg-surface-tonal-bold"
            }`}
          >
            <Typo
              element="span"
              type="labelSM"
              smType="labelXS"
              textColor={isActive ? "text-white" : "text-text-primary"}
            >
              {option.label}
            </Typo>
          </button>
        );
      })}
    </div>
  );

  if (layout === "inline") {
    return (
      <div
        className={`flex items-center justify-between pb-4 pt-4 ${
          hideDivider ? "" : "border-b border-stroke-primary"
        }`}
      >
        {label && (
          <Typo element="p" type="labelSM">
            {label}
          </Typo>
        )}
        {buttons}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {label && (
        <Typo element="p" type="labelSM">
          {label}
        </Typo>
      )}
      {buttons}
    </div>
  );
};
